/*
 * Module for wrapping and initializing a signalr-based logviewer connection
 */
rs.module("controls/diagnostics/logviewer",

    ["controls/diagnostics/logviewer/logparser", "ui/framework/client-templates"],

    function (logParser, clientTemplates) {

        function initialize(
            jsSelectors,
            url,
            connectImmediately,
            templateKeys) {

            // The controls we need
            var control = $.js(jsSelectors.control);
            var logConsole = control.js(jsSelectors.console);
            var filterSelect = control.js(jsSelectors.filter);
            var commandButton = control.js(jsSelectors.commandButton);

            // Default filter
            var filter = (p) => {
                return true;
            };

            //
            // Filter change
            //
            filterSelect.on("change", function () {

                var filterValue = filterSelect.val();
                if (filterValue.indexOf("=") > -1) {
                    var [dottedPropertyName, matchValue] = filterValue.split("=", 2);

                    filter = (p) => {
                        // dot notation to dive down into the object 
                        var propertyValue = dottedPropertyName.split('.').reduce((a, b) => a == null ? a : a[b], p);
                        return propertyValue == matchValue;
                    };

                    applyFilter();
                }
                else {
                    filter = (p) => true;
                    applyFilter();
                }
            });

            // is the last log line we processed an Error
            var previousEntryError = false;
            var previousProperties = null;

            const connection = new signalR.HubConnectionBuilder()
                .withUrl(url)
                .withAutomaticReconnect()
                .configureLogging(signalR.LogLevel.Error)
                .build();

            // Listen for Start/Stop
            commandButton.click(function () {
                if ($(this).html() == "Stop") {
                    stopConnection();
                }
                else {
                    startConnection();
                }
            });

            // Start the connection 
            if (connectImmediately) {
                startConnection();
            }
           
            //
            // Receiving an 'Alert'
            //
            connection.on("Alert", function (message) {
                writeAlert(message);
            });

            //
            // Receiving logs
            //
            connection.on("ReceiveLogs", function (reason, logs) {

                logs.forEach(function (line) {

                    var newItem;

                    let parsed = logParser.parseLog(line.text);
                    var properties = {};

                    // If there's more than just a message...
                    if (!parsed.messageOnly) {

                        try {
                            // multi-line entries may not have properties so we have to protected against it
                            if (parsed.properties) {
                                properties = JSON.parse(logParser.propertiesToJSON(parsed.properties));
                                previousProperties = properties;
                            }
                            else {
                                properties = {};
                            }
                        }
                        catch (err) {
                            console.error(err);
                            properties = {};
                        }

                        // Create the new html line
                        newItem = $(clientTemplates.render(templateKeys.fullLine,
                            {
                                line: line,
                                parsed: parsed,
                                level: parsed.level.toLowerCase(),
                                historic: !isNewItem(reason)
                            }));

                        // Associate it with its properties
                        $.extend(properties, parsed);
                        newItem.data("properties", properties);

                        // Next time we'll need to know if there was an error this time
                        previousEntryError = (parsed.level === "Error");
                    }
                    else {

                        // Create the new html line - just a message (potentially a stack trace line if 'previousEntryError' is true)
                        newItem = $(clientTemplates.render(templateKeys.messageLine,
                            {
                                line: line,
                                parsed: parsed,
                                stackTrace: previousEntryError,
                                historic: !isNewItem(reason)
                            }));

                        // Associate it with the previous properties we saw
                        newItem.data("properties", previousProperties);

                        // We should show\hide based on the previous properties so we go along with our parent
                        properties = previousProperties;
                    }

                    // see if we should show or hide this based on the filter
                    if (!filter(properties)) {
                        newItem.hide();
                    }

                    logConsole.append(newItem);

                    // scrollHeight calculation is expensive, if we are bulk-loading history, skip it
                    // and do it at the end.  Massive performance problem in Edge
                    if (isNewItem(reason)) {
                        $(logConsole[0]).scrollTop(logConsole[0].scrollHeight);
                    }
                });

                if (!isNewItem(reason)) {
                    $(logConsole[0]).scrollTop(logConsole[0].scrollHeight);
                }
            });

            // Write an alert message to the console, wrapped by asterisks
            function writeAlert(message) {
                logConsole.append(clientTemplates.render(templateKeys.alert, { message: message }));
            }

            // Indicates if the given reason represents a new item (or false if historic)
            function isNewItem(reasonCode) {
                return reasonCode !== 1;
            }

            // Apply the current filter to the log items
            function applyFilter() {
                logConsole.children().each(function () {
                    var properties = $(this).data("properties");

                    if (properties && filter(properties)) {
                        // show the row
                        $(this).show();
                    }
                    else {
                        // hide the row
                        $(this).hide();
                    }
                });
            }

            // Stop the SignalR connection
            function stopConnection() {
                connection.stop();
                commandButton.html("Start");
            }

            // Start the SignlaR connection
            function startConnection() {
                logConsole.empty();
                connection.start().catch(err => console.error(err.toString()));
                commandButton.html("Stop");
            }
        }

        // the interface to the control
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);